import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import SideBarCoordinator from "../SideBar/SideBarCoordinator";

import "./Layout.css";
import { Suspense, useState } from "react";
import LoadingOverlay from "../Custom/LoadingOverlay";
import MenuPopup from "./MenuPopup";
import useGroupMessaging from "../../customHooks/globalCustomHooks/useGroupMessaging";
import useOneOnOneMessaging from "../../customHooks/globalCustomHooks/useOneOnOneMessaging";
import useFetchUnreadMsgChatRoomsCount from "../../customHooks/globalCustomHooks/useFetchUnreadMsgChatRoomsCount";
import useNoteOneOnOneMessagingEvents from "../../customHooks/socketEvents/noteOneOnOneMessaging/useNoteOneOnOneMessagingEvents";
import { useSelector } from "react-redux";
import useNoteOneOnOneSetupEvents from "../../customHooks/socketEvents/noteOneOnOneMessaging/useNoteOneOnOneSetupEvents";

const LayoutCoordinator = () => {
  const [toggleSideBarData, setToggleSideBarData] = useState({
    open: true,
    priorityOpen: false,
  });
  const { eventInfo, eventNotesAssignUser } = useSelector(
    (state) => state.eventRequestDetails
  );

  // custom hooks start...
  // group messaging custom hooks...
  useGroupMessaging();
  // group messaging custom hooks...

  // oneOnOne messaging custom hooks...
  useOneOnOneMessaging();
  // oneOnOne messaging custom hooks...

  // fetchUnreadMsgChatRoomsCount hooks...
  useFetchUnreadMsgChatRoomsCount();
  // fetchUnreadMsgChatRoomsCount hooks...

  // note socket event listener custom hook...
  useNoteOneOnOneMessagingEvents({
    roomIds: eventNotesAssignUser?.[0]?.chatId
      ? [eventNotesAssignUser?.[0]?.chatId]
      : [""],
    eventInfo,
  });
  // note socket event listener custom hook...

  useNoteOneOnOneSetupEvents();
  // custom hooks end...

  return (
    <Box sx={{ width: "100%" }}>
      {/* <NavBarClient /> */}
      <Box
        sx={{
          padding: "40px",
          display: "flex",
          gap: "16px",
          alignItems: "flex-start",
          "@media (max-width: 1200px)": {
            flexDirection: "column",
            paddingTop: "20px",
            "& > div:first-of-type": {
              display: "none",
            },
          },
          "@media (max-width: 600px)": {
            padding: "15px",
          },
        }}
      >
        <SideBarCoordinator
          toggleSideBarData={toggleSideBarData}
          setToggleSideBarData={setToggleSideBarData}
        />
        <MenuPopup>
          <SideBarCoordinator />
        </MenuPopup>
        <Box
          data-route-scroll-root
          onClick={(e) => {
            // e.stopPropagation();
            if (!toggleSideBarData.priorityOpen) {
              setToggleSideBarData({ ...toggleSideBarData, open: false });
            }
          }}
          sx={{
            display: "flex",
            flexDirection: "column",
            position: "relative",
            flex: "1",
            width: "100%",
            borderRadius: "16px",
            padding: "0",
            border: "2px solid #D175B6",
            background: "rgba(0, 0, 0, 0.50)",
            // background: "red",
            minHeight: "calc(100vh - 204px)",
            // minWidth: "calc(100vw - 396px)",
            overflow: "scroll",
            "&::-webkit-scrollbar": {
              width: 0, // Hide scrollbar on WebKit browsers (e.g., Chrome, Safari)
            },
            scrollbarWidth: "none", // Hide scrollbar on Firefox
          }}
        >
          <Suspense fallback={<LoadingOverlay open={true} />}>
            <Outlet />
          </Suspense>
        </Box>
      </Box>
    </Box>
  );
};

export default LayoutCoordinator;

LayoutCoordinator.propTypes = {
  children: PropTypes.node,
};
